import { render, staticRenderFns } from "./OffCanvasNav.vue?vue&type=template&id=04a0c1ec&"
import script from "./OffCanvasNav.vue?vue&type=script&lang=js&"
export * from "./OffCanvasNav.vue?vue&type=script&lang=js&"
import style0 from "./OffCanvasNav.vue?vue&type=style&index=0&id=04a0c1ec&prod&lang=scss&"
import style1 from "./OffCanvasNav.vue?vue&type=style&index=1&id=04a0c1ec&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports